module.exports = __webpack_public_path__ + "img/2_1-industriale-fabbrica_a-1.6418a003.png";